import React from 'react';
import {List, Map} from 'immutable';
import {getValueAtPathOfClosestParent} from "../../utils/utils";
import _ from 'lodash';

function getIndexesByItem(items) {
    return Map(items.reduce((map, item, index) => { map[item] = index; return map; }, {}));
}

function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export const Direction = {
    Horizontal: 'horizontal',
    Vertical: 'vertical'
};

export function withReorder(options) {
    return function(WrappedComponent) {
        class WithReorder extends React.Component {

            static propTypes = {};

            static defaultProps = {};

            constructor(props) {
                super(props);

                this.direction = options.direction;
                this.itemSize = options.itemSize;
                this.onMouseMoveHandler = _.curry(this.onMouseMoveHandler);

                this.state = {
                    reordering: false,
                    reorderItems: null,
                    indexesByItem: null,
                    draggedItem: null,
                    referenceX: null,
                    referenceY: null,
                    translateX: null,
                    translateY: null
                };
            }

            beginReorder = (reorderItems) => {
                this.setState({
                    reordering: true,
                    reorderItems: List(reorderItems),
                    indexesByItem: getIndexesByItem(reorderItems),
                });
            };

            resetReorder = () => {
                this.setState({
                    reordering: false,
                    reorderItems: null,
                    indexesByItem: null,
                    draggedItem: null,
                    referenceX: null,
                    referenceY: null,
                    translateX: null,
                    translateY: null
                });
            };

            indexOfItem = (item) => {
                return this.state.reordering ? this.state.indexesByItem.get(item) : null;
            };

            onMouseDown = (event) => {
                event.preventDefault();

                document.addEventListener('mousemove', this.onMouseMove, false);
                document.addEventListener('mouseup', this.onMouseUp, false);

                let draggedItem = getValueAtPathOfClosestParent(event.currentTarget, 'dataset.reorderItem');
                let newState = {
                    draggedItem: draggedItem
                };

                if (this.direction === Direction.Horizontal) {
                    newState.referenceX = event.clientX;
                    newState.translateX = 0;
                } else {
                    newState.referenceY = event.clientY;
                    newState.translateY = 0;
                }

                this.setState(newState);
            };

            onMouseMove = (event) => {
                event.preventDefault();
                this.setState(this.onMouseMoveHandler(event));
            };

            onMouseMoveHandler = (event, prevState) => {
                let orderChanged = false;
                let items = prevState.reorderItems.toJS();
                let reference = null;
                let translate = null;
                if (this.direction === Direction.Horizontal) {
                    reference = prevState.referenceX;
                    translate = event.clientX - reference;

                } else {
                    reference = prevState.referenceY;
                    translate = event.clientY - reference;
                }
                let itemIndex = prevState.indexesByItem.get(prevState.draggedItem);
                let direction = translate / Math.abs(translate);
                let maxJumps = direction > 0 ? items.length - 1 - itemIndex : itemIndex;
                let half = Math.ceil(this.itemSize / 2) - 1;
                let numOfJumps = Math.floor((Math.abs(translate) + half) / this.itemSize);
                let jumps = Math.min(maxJumps, numOfJumps);

                if (jumps > 0) {
                    orderChanged = true;
                    translate -= this.itemSize * direction;
                    reference += this.itemSize * jumps * direction;
                    let item = items[itemIndex];
                    items.splice(itemIndex, 1);
                    itemIndex += direction * jumps;
                    items.splice(itemIndex, 0, item);
                }

                if ((itemIndex === 0 && translate < 0) || (itemIndex === items.length - 1 && translate > 0)) {
                    translate = 0;
                }

                let newState = {};

                if (orderChanged) {
                    newState.reorderItems = List(items);
                    newState.indexesByItem = getIndexesByItem(items);
                }

                if (this.direction === Direction.Horizontal) {
                    newState.referenceX = reference;
                    newState.translateX = translate;
                } else {
                    newState.referenceY = reference;
                    newState.translateY = translate;
                }

                return newState;
            };

            onMouseUp = (event) => {
                event.preventDefault();

                document.removeEventListener('mousemove', this.onMouseMove, false);
                document.removeEventListener('mouseup', this.onMouseUp, false);

                this.setState({
                    draggedItem: null,
                    referenceX: null,
                    referenceY: null,
                    translateX: null,
                    translateY: null
                });
            };

            render() {
                let injectedProp = Object.assign({
                    beginReorder: this.beginReorder,
                    resetReorder: this.resetReorder,
                    onMouseDown: this.onMouseDown,
                    indexOfItem: this.indexOfItem,
                    reordering: this.state.reordering,
                    reorderItems: this.state.reorderItems ? this.state.reorderItems.toJS() : null,
                    draggedItem: this.state.draggedItem,
                    translateX: this.state.translateX,
                    translateY: this.state.translateY
                });
                return (
                    <WrappedComponent {...this.props} {...injectedProp} />
                );
            }
        }
        WithReorder.displayName = `WithReorder(${getDisplayName(WrappedComponent)})`;
        return WithReorder;
    }
}



// WEBPACK FOOTER //
// ./src/components/withReorder/WithReorder.js